import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatAccordion, MatSnackBar } from '@angular/material';
// Import  TranslateService
import { TranslateService } from '@ngx-translate/core';
import { DefaultLanguageStringsService } from 'app/core/language/services/default-language-strings.service';
import { RecommendationCategoryMultiInterface } from 'app/recommendation/models/recommendation-category-multi.model';
import { RecommendationCategoryInterface } from 'app/recommendation/models/recommendation-category.model';
import { RecommendationService } from 'app/recommendation/services/recommendation.service';
import { SiteSupportedLanguageInterface } from 'app/site-settings/models/site-supported-language.model';
import { Subject } from 'rxjs';

@Component({
  selector: 'cz-recommendations-configuration-category-dialog',
  templateUrl: './recommendations-configuration-category-dialog.component.html',
  styleUrls: ['./recommendations-configuration-category-dialog.component.scss'],
})
export class RecommendationsConfigurationCategoryDialogComponent implements OnInit, OnDestroy {
  /*  */
  public supportedlanguage: SiteSupportedLanguageInterface[];
  public addForm: FormGroup;
  public rows: FormArray;
  public defaultLanguage: number;
  public panelOpenState: boolean = false;
  public addNewCategoryForm: FormGroup;
  public isButtonDisabled: boolean = true;
  @ViewChild('recommendationCategoryItemsAccordion') public myCategoryPanels: MatAccordion;
  /*  */
  public addNewCategory:  boolean = true;
  public itemsExist:      boolean = true;
  public categoryTitleControl: FormControl;

  public categoryData: RecommendationCategoryInterface;

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
// Inject TranslateService
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { languages: SiteSupportedLanguageInterface[], category: RecommendationCategoryInterface },
    public readonly _defaultStrings: DefaultLanguageStringsService,
    private readonly _recommendationService: RecommendationService,
    private _translateService: TranslateService,
    private _formBuilder: FormBuilder,
    private readonly _snackBar: MatSnackBar) {

    this.categoryTitleControl = new FormControl();
    this.initializeFormControls();
  }

  public ngOnInit():void {
    this.addNewCategoryForm = this._formBuilder.group({
      categoryTitleControl: ['', Validators.required],
    });
    this.categoryData = this.data.category;
    this.supportedlanguage = this.data.languages.filter((list: SiteSupportedLanguageInterface) => {
      if (list.isDefault) {
        this.defaultLanguage = list.languageId;
      }
      if (list.isSupported) {
        return list;
      }
    });
    if (this.categoryData && this.categoryData.id > 0 && this.supportedlanguage.length === 1) {
      this.addNewCategory = false;
      let name: string = '';
      this.categoryData.categoryMullang.map((item: RecommendationCategoryMultiInterface) => {
        if (item.languageId === this.defaultLanguage) {
          name = item.title;
        }
      });
      this.addNewCategoryForm.patchValue({
        categoryTitleControl: name,
      });
    }


    if (this.categoryData && this.categoryData.id > 0) {
      this.addNewCategory = false;

      this.supportedlanguage.map((list: SiteSupportedLanguageInterface) => {
        this.rows.push(this.createItemFormGroup(list));
      });
      this.addForm.addControl('rows', this.rows);
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public saveCategory(): void {
    let validData: boolean;
    if (this.categoryData && this.categoryData.id > 0) {
      validData = true;
      if (this.supportedlanguage.length > 1) {
        this.categoryData = {
          ...this.categoryData,
          categoryMullang: this.rows.value,
        };
      } else {
        let mulLang: RecommendationCategoryMultiInterface[];
        mulLang = this.categoryData.categoryMullang.map((item: RecommendationCategoryMultiInterface) => {
          if (item.languageId === this.defaultLanguage) {
            return {
              ...item,
              title: this.addNewCategoryForm.get('categoryTitleControl').value,
            };
          }
          return item;
        });
        this.categoryData = {
          ...this.categoryData,
          categoryMullang: mulLang,
        };
      }
    } else {
      if (this.addNewCategoryForm.valid) {
        validData = true;
      } else {
        validData = false;
        this.showValidationMsg(this.addNewCategoryForm);
      }
      this.categoryData = {
        ...this.categoryData,
        categoryMullang: [{
          languageId: this.defaultLanguage,
          title: this.addNewCategoryForm.get('categoryTitleControl').value,
        }],
      };
    }



    if (this.categoryData.categoryMullang.length > 0 && validData) {
      if (this.categoryData.id > 0) {
        this._recommendationService.updateRecommendationCategory(this.categoryData);
        // Static text to Language Variable updated
        const name: string = this.getCategoryNmae(this.categoryData);
        this.showSnackBar(name + this._translateService.instant('$message_updated'));
      } else {
        this._recommendationService.createRecommendationCategory(this.categoryData);
        // Static text to Language Variable updated

        this.showSnackBar(this.addNewCategoryForm.get('categoryTitleControl').value + this._translateService.instant('$message_created'));

        this.addNewCategoryForm.reset();
        this.addNewCategoryForm.setErrors({});

      }
    } else {
      // this.categoryTitleControl.updateValueAndValidity();
    }
  }

  public resetAddNewCategoryForm(formDirective: FormGroupDirective): void {
    if (this.addNewCategoryForm.valid) {
      formDirective.resetForm();
    }
  }
  public showValidationMsg(formGroup: FormGroup): void {

    for (const key in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(key)) {
        const control: FormControl = <FormControl>formGroup.controls[key];

        if (Object.keys(control).includes('controls')) {
          const formGroupChild: FormGroup = <FormGroup>formGroup.controls[key];
          this.showValidationMsg(formGroupChild);
        }

        control.markAsTouched();
      }
    }
  }
  public getCategoryNmae(category: RecommendationCategoryInterface): string {
    let categoryName: string = '';

    if (category.categoryMullang !== undefined && category.categoryMullang.length > 0) {
      category.categoryMullang.map((item: RecommendationCategoryMultiInterface) => {
        if (item.languageId === this.defaultLanguage) {
          categoryName = item.title;
        }
      });
    }
    return categoryName;
  }
  public showSnackBar(message: string): void {
    // Static text to Language Variable updated
    this._snackBar.open(this._translateService.instant('$message_category') + message, undefined, {
      duration: 5000,
    });
  }
/* Multi */
  public openAll(): void {
    this.myCategoryPanels.openAll();
    this.panelOpenState = true;
  }
  public closeAll(): void {
    this.myCategoryPanels.closeAll();
    this.panelOpenState = false;
  }
  public getLanguageeName(id: number): any {
    const name: SiteSupportedLanguageInterface[] = this.supportedlanguage.filter((list: SiteSupportedLanguageInterface) => {
      if (list.languageId === id) {
        return list;
      }
    });
    return this._defaultStrings.defaultStringArray[name[0].label];
  }
  public isDefaultInput(): void {

    this.isButtonDisabled = true;
    this.rows.value.map((item: RecommendationCategoryMultiInterface) => {
      if (item.languageId === this.defaultLanguage && item.title !== null && item.title !== undefined && item.title !== '') {
        this.isButtonDisabled = false;
      }
    });

  }
  private initializeFormControls(): void {
    this.addForm = this._formBuilder.group({});
    this.rows = this._formBuilder.array([]);
  }

  private createItemFormGroup(data: SiteSupportedLanguageInterface): FormGroup {
    const dbData: RecommendationCategoryMultiInterface[] =
      this.categoryData.categoryMullang.filter((list: RecommendationCategoryMultiInterface) => {
        if (data.languageId === list.languageId) {
          return list;
        }
      });


    let name: string = '';
    const lanId: number = data.languageId;
    if (dbData.length > 0) {
      name = dbData[0].title;
    }

    if (data.isDefault && name !== '' && name !== undefined) {
      this.isButtonDisabled = false;
    }
   // var name: string = '';
   // const lanId: number = data.languageId;
    return this._formBuilder.group({
      title: name,
      languageId: lanId,
    });
  }

}
